export default {
  // Document titles
  'quotation.preliminary': '初步报价单',
  'quotation.finalOffer': '最终报价单',

  // Meta
  'quotation.quoteNumber': '报价编号',
  'quotation.offerNumber': '最终报价编号',
  'quotation.status': '状态',
  'quotation.createdDate': '创建日期',
  'quotation.quoteType': '报价类型',
  'quotation.quoteCurrency': '报价币种',
  'quotation.issuedDate': '签发日期',
  'quotation.validUntil': '有效期至',
  'quotation.reference': '相关初步报价',

  // Sections
  'quotation.buyerInfo': '买方信息',
  'quotation.products': '产品',
  'quotation.finishing': '表面处理 / 装饰',
  'quotation.printing': '印刷',
  'quotation.specialRequirements': '特殊要求',
  'quotation.pricingSummary': '价格汇总',
  'quotation.commercialCharges': '商务费用',
  'quotation.commercialTerms': '商务条款',

  // Pricing rows
  'quotation.productSubtotal': '产品小计',
  'quotation.finishingSubtotal': '表面处理小计',
  'quotation.preliminaryTotal': '初步报价合计',
  'quotation.preliminaryQuoteTotal': '初步报价合计',
  'quotation.finalTotal': '最终合计',

  // Commercial charges
  'quotation.freight': '运费',
  'quotation.insurance': '保险',
  'quotation.customsClearance': '清关',
  'quotation.duty': '关税',
  'quotation.tax': '税费 / 增值税',
  'quotation.manualAdjustment': '手动调整',
  'quotation.discount': '折扣',

  // Commercial terms
  'quotation.paymentTerms': '付款条件',
  'quotation.leadTime': '交货周期',
  'quotation.deliveryTerms': '交付条款',
  'quotation.incoterms': '国际贸易术语',
  'quotation.commercialNotes': '商务备注',

  // Product detail fields
  'quotation.quantity': '数量',
  'quotation.unitPrice': '单价',
  'quotation.amount': '金额',
  'quotation.sku': 'SKU',
  'quotation.material': '材质',
  'quotation.capacity': '容量',
  'quotation.specification': '规格',

  // Buyer fields
  'quotation.companyName': '公司名称',
  'quotation.contactPerson': '联系人',
  'quotation.country': '国家',
  'quotation.address': '地址',
  'quotation.email': '邮箱',
  'quotation.phone': '电话',

  // PDF
  'quotation.pdfView': '查看 PDF',
  'quotation.pdfDownload': '下载 PDF',
  'quotation.pdfGenerating': '正在生成 PDF...',
  'quotation.pdfError': '无法生成 PDF，请重试。',
  'quotation.pdfClose': '关闭',
  'quotation.pdfOpenNewTab': '在新标签页打开',

  // Quote type
  'quotation.type.production': '量产',
  'quotation.type.sample': '样品',
};